/* eslint-disable prefer-rest-params */
import { reactive } from 'vue';

const eventBus = reactive({
  data: null,
  events: {},
  $emit() {
    //evoke the callback that was set from '$on' with the trailing arguments
    const key = arguments[0];
    const values = [];
    for (let i = 1; i < arguments.length; i++) {
      values.push(arguments[i]);
    }
    this.events[key](...values);
  },
  $on() {
    //the event name is the first argument, the callback is the second
    this.events[arguments[0]] = arguments[1];
  }
});

export default eventBus;
